// Required MUI and app component imports
import Grid from "@mui/material/Grid2";
import QueryButton from "../common/querybutton";
import "./suggestion.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import {
  getChoiceApi,
  getModifyClassdataApi,
} from "../../redux/action/UserAction";
import { useDispatch, useSelector } from "react-redux";
import {
  conversationByIdReduc,
  userSelector,
} from "../../redux/slices/userSlice";
import Loader from "../loader";
import AlertDialogSlide from "../sidebar/deleteModal";
import { Tooltip } from "@mui/material";

// Component for modifying suggestion input fields with formik and Redux state
const ModifySuggestion = ({
  onModifyClick,
  resdata,
  seteditGenerateQuery = () => {},
  conversationById,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  let idd = location?.state?.id;

  // Extract relevant Redux states
  const {
    classDataLoading,
    modalClassesLoading,
    modifyClassData,
    optionsData,
  } = useSelector(userSelector);

  // Local component state
  const [shouldFetch, setShouldFetch] = useState(true);
  const [open, setOpen] = useState(false); // For delete modal, not actively used

  // Navigate to modify query page with prefilled values
  const handleModifyQuery = () => {
    const oldquery =
      conversationById?.queries?.[0]?.query || conversationById?.query;
    const oldOptions =
      conversationById?.queries?.[0]?.modify_input ||
      conversationById?.modify_input;
    const convoId = conversationById?.queries?.[0]?.conversation_id;
    seteditGenerateQuery(oldquery);

    navigate("/newquery", {
      state: {
        oldq: oldquery,
        isModifyQuery: true,
        options: oldOptions ?? formik?.values,
        convoId: convoId,
      },
    });
  };

  // Formik form to manage form values for suggestion modification
  const formik = useFormik({
    initialValues: {
      subject: "",
    },
    validateOnChange: true,
    onSubmit: (values) => {
      onModifyClick(values); // Submit updated form values to parent
    },
  });

  // Fetch choice options on mount
  useEffect(() => {
    dispatch(getChoiceApi());
  }, []);

  // Fetch modified class data only once when component mounts
  useEffect(() => {
    const fetchData = async () => {
      if (shouldFetch) {
        dispatch(getModifyClassdataApi());
        setShouldFetch(false);
      }
    };
    fetchData();
  }, [shouldFetch]);

  // Set form values based on previous conversation data
  useEffect(() => {
    if (optionsData === null || optionsData === "") {
      // Reset with default empty fields
      const emptyvalues = {
        subject: "",
        language: "",
        output: "",
        length: "",
        audience: "",
      };
      formik.resetForm({ values: emptyvalues });
    } else {
      // Pre-fill form with previous data if available
      const emptyvalues = {
        subject: "",
        language: "",
        output: "",
        length: "",
        audience: "",
      };
      formik.resetForm({ values: emptyvalues });

      formik.resetForm({
        values: optionsData,
      });
    }
  }, [idd, conversationById]);

  return (
    <>
      {/* Optional delete confirmation modal */}
      {open && (
        <AlertDialogSlide
          open={open}
          setOpen={setOpen}
          setShouldFetch={setShouldFetch}
        />
      )}

      {/* Loader while data is fetching */}
      {modalClassesLoading ? (
        <Loader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <Grid className="container" container alignItems="stretch" spacing={2}>
            {/* Show loader while loading class data */}
            {classDataLoading ? (
              <Loader />
            ) : (
              modifyClassData?.map((data) => {
                return (
                  <>
                    {/* Label column for each field */}
                    <Grid
                      key={data?.name}
                      size={{ lg: 3, md: 3, xs: 3 }}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "80%" }}>
                        <div className="suggestionContainer">
                          <p key={data?.name} style={{ margin: 0, width: "50%" }}>
                            {data?.name}
                          </p>
                          <Tooltip title={data?.name}>
                            <InfoIcon
                              sx={{
                                fontSize: "18px",
                                width: "40%",
                                color: "grey",
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </Grid>

                    {/* Input field column */}
                    <Grid size={{ lg: 9, md: 9, xs: 9 }}>
                      <input
                        value={formik?.values[data?.name]}
                        onChange={formik.handleChange}
                        name={data?.name}
                        placeholder={"Fill in"}
                        type="text"
                        className="suggestioninput"
                      />
                    </Grid>
                  </>
                );
              })
            )}

            {/* Form buttons */}
            <div className="suggestioncontentbtn">
              <QueryButton
                type={"button"}
                btntext={"Modify Response"}
                btnclick={() => formik.handleSubmit()}
              />
              <QueryButton
                btnclick={() => handleModifyQuery()}
                btntext={"Modify Query"}
              />
            </div>
          </Grid>
        </form>
      )}
    </>
  );
};

export default ModifySuggestion;
